import Vuex from "vuex"

import { db, auth } from "@/firebase"

//import tekenaars from './modules/tekenaars'
// import db from '../firebase/firebaseInit'

import user from "./modules/user"
import emailpopup from "./modules/emailpopup"
import uploadFile from "./modules/uploadFile"

import firebase from "firebase"

const functions = firebase.functions()

const setStatusByNewModel = opdracht => {
  if (opdracht.facturen?.length) return "Beëindigd"

  const event =
    opdracht.status
      .slice()
      .reverse()
      .filter(e => e.event > 9)[0]?.event || 0

  console.log(event)

  // if (event === 0) return "Geannuleerd"
  if (event === 10) return "Nieuw"
  if (event === 20) return "In behandeling"
  if (event === 30) return "Uitgezet"
  if (event === 40) return "Geaccepteerd"
  if (event === 50) return "Intake"
  if (event === 60) return "Gestart"
  if (event === 70) return "Beëindigd"
  return opdracht.status
}

export default Vuex.createStore({
  modules: {
    user,
    emailpopup,
    uploadFile
  },

  state: {
    adminId: "",

    selectedOpdrachtId: "",
    userAccounts: [],
    showNewProfileModal: false,
    selectedUserProfileId: null,
    statussen: ["Nieuw", "Toegewezen", "Uitgezet", "Geaccepteerd", "Gestart", "Beëindigd"],
    disciplines: ["Bouwkunde", "Werktuigbouwkunde", "Installatietechniek", "Elektrotechniek", "Brandpreventie", "Huisvesting", "Plattegronden", "Concepten - 3D Print", "Nen2580", "Sem"],
    disciplines_lowercase: ["bouwkunde", "werktuigbouwkunde", "installatietechniek", "elektrotechniek", "brandpreventie", "huisvesting", "plattegronden", "concepten -3d print", "nen2580", "sem"],

    status: {},

    tekenaars: [],
    opdrachten: [],
    facturen: [],

    opdrachtid: "yHKq2fUVNZYLYX5HUQ2b", // depricated => from now on: 'selectedOpdrachtId'

    showTekFilters: false,
    showNewProfiles: false,
    tekFilters: {
      name: "",
      email: "",
      telefoonnummer: "",
      disciplines: "",
      bedrijfsnaam: "",
      berekeningen: "",
      nen2580: "",
      woonplaats: "",
      werkgebied: "",
      tekenprogramma: ""
    },

    showOpdrFilters: false,
    opdrFilters: {
      opdrachtnummer: "",
      status: "",
      telefoonnummer: "",
      disciplines: "",
      bedrijfsnaam: ""
    },
    showOpdrOnHold: false,
    showOpdrGeannuleerd: false,
    showOpdrBeëindigd: false
  },

  mutations: {
    setFacturen: (state, payload) => (state.facturen = payload),

    setAdminId: (state, payload) => (state.adminId = payload),

    setSelectedOpdrachtId: (state, payload) => (state.selectedOpdrachtId = payload),
    set_userAccounts(state, payload) {
      state.userAccounts = payload
    },
    setStatus(state, payload) {
      state.status = payload
    },
    setSelectedUserProfileId: (state, e) => (state.selectedUserProfileId = e),
    setShowNewProfileModal: state => (state.showNewProfileModal = !state.showNewProfileModal),
    setShowNewProfiles: (state, e) => (state.showNewProfiles = e),
    // setStatus: (state, status) => (state.status = status),
    setTekenaars: (state, tekenaars) => (state.tekenaars = tekenaars),
    setOpdrachten: (state, opdrachten) => {
      state.opdrachten = opdrachten
    },

    updateTekFilters(state, payload) {
      state.tekFilters = payload
    },

    toggleShowTekFilters(state, payload) {
      state.showTekFilters = payload
    },

    updateOpdrFilters(state, payload) {
      state.opdrFilters = payload
    },
    toggleShowOpdrFilters: (state, payload) => (state.showOpdrFilters = payload),
    toggleShowOpdrOnHold(state, payload) {
      if (state.showOpdrOnHold == payload) {
        state.showOpdrOnHold = !payload
      }
    },
    toggleShowOpdrGeannuleerd(state, payload) {
      if (state.showOpdrGeannuleerd == payload) {
        state.showOpdrGeannuleerd = !payload
      }
    },
    toggleShowOpdrBeëindigd(state, payload) {
      if (state.showOpdrBeëindigd == payload) {
        state.showOpdrBeëindigd = !payload
      }
    }
  },

  getters: {
    selectedOpdracht: state => state.opdrachten.find(e => e.id === state.selectedOpdrachtId),
    allTekenaars: state => state.tekenaars,
    allOpdrachten: state => state.opdrachten,
    allDisciplines: state => state.disciplines
  },

  actions: {
    startFirebase({ commit, dispatch }) {
      auth.onAuthStateChanged(user => {
        if (user) {
          commit("SET_USER", user.uid)
          dispatch("downloadUserData", user)

          // dispatch("downloadUserData", user)
          // dispatch("getOpdrachten")
        } else {
          commit("SET_USER", "")
          commit("setAdminId", "")
        }
      })
    },

    downloadUserData({ commit, dispatch }, user) {
      db.collection("users")
        .doc(user.uid)
        .onSnapshot(async doc => {
          if (doc.data()) {
            if (doc.data().userType !== "admin") {
              dispatch("logout")
              commit("SET_USER", "")
              commit("setAdminId", "")
            } else {
              commit("setAdminId", user.uid)
              await dispatch("fetchFacturen")
              dispatch("fetchTekenaren")
              dispatch("fetchOpdrachten")
              dispatch("fetchTodos")
              dispatch("fetchStatus")
              commit("SET_LOGGED_IN", true)
            }
          } else {
            commit("SET_USER", "")
            dispatch("logout")
          }
        })
    },

    logout({ commit }) {
      commit("SET_USER", "")
      commit("setTekenaars", [])
      commit("set_userAccounts", [])
      commit("setOpdrachten", [])
      auth.signOut()
    },

    //Email akkoordmail naar tek bij nieuwe opdr
    async testZapierWebhook() {
      const callable = functions.httpsCallable("deleteTekenaar")
      return callable().then(() =>
        // do something here
        alert("webhook functie getriggerd")
      )
    },

    async fetchStatus({ commit }) {
      db.collection("status")
        .doc("status")
        .onSnapshot(function(doc) {
          commit("setStatus", doc.data())
        })
    },

    async setMessengerStatusFalse() {
      try {
        db.collection("status")
          .doc("status")
          .set({
            messenger: false
          })
      } catch (error) {
        console.error("Error writing document: ", error)
        alert("Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur")
      }
    },

    async fetchFacturen({ commit }) {
      db.collection(`facturen-incoming`).onSnapshot(resultArray => {
        let newArray = []
        resultArray.forEach(doc => {
          const factuur = {
            ...doc.data(),
            id: doc.id
          }
          newArray.push(factuur)
        })
        commit("setFacturen", newArray)
        console.log("🧾", newArray)
      })
    },

    async fetchTekenaren({ commit }) {
      let list = []
      db.collection("tekenaars")
        .where("kvkingeschreven", "==", "Ja")
        .limit(5)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //const data = doc.data()
            const data = {
              id: doc.id || "",
              voornaam: doc.data().voornaam || "",
              achternaam: doc.data().achternaam || "",
              naam: doc.data().voornaam + " " + doc.data().achternaam || "",
              disciplines: doc.data().disciplines || ["geen disciplines..."],
              aantekening: doc.data().aantekening || "",
              email: doc.data().email || "",
              telefoonnummer: doc.data().telefoonnummer || "",
              tekenprogramma: doc.data().tekenprogramma || "",
              woonplaats: doc.data().woonplaats || "",
              bedrijfsnaam: doc.data().bedrijfsnaam || "",
              website: doc.data().website || "",
              opleiding: doc.data().opleiding || "",
              kvknummer: doc.data().kvknummer || "",
              rating: doc.data().rating || 0,
              werkgebied: doc.data().werkgebied || "",
              adres: doc.data().adres || "",
              log: doc.data().log || ""
            }
            list.push(data)
          })
        })
      commit("setTekenaars", list)
    },

    async getUserAccountsOfTekenaars({ commit }) {
      db.collection(`users`).onSnapshot(resultArray => {
        let newArray = []
        resultArray.forEach(user => {
          const userBlock = {
            ...user.data(),
            id: user.id
          }
          if (user.data().userType === "tekenaar") newArray.push(userBlock)
        })
        commit("set_userAccounts", newArray)
      })
    },

    async fetchOpdrachten({ state, commit, dispatch }) {
      dispatch("getUserAccountsOfTekenaars")

      db.collection("opdrachten")
        .orderBy("metadata.opdrachtNummer")
        .onSnapshot(res => {
          let newArray = []
          res.forEach(opdracht => {
            const obj = {
              ...opdracht.data(),
              id: opdracht.id,
              statusString: setStatusByNewModel({ ...opdracht.data(), id: opdracht.id, facturen: [...state.facturen].filter(factuur => factuur.opdrachtId === opdracht.id && factuur.type !== "btwFactuur") || [] }),
              facturen: [...state.facturen].filter(factuur => factuur.opdrachtId === opdracht.id) || []
              // onhold: false,
              // discipline: opdracht.data().disciplines || "",
            }
            newArray.push(obj)
          })
          commit("setOpdrachten", newArray)
        })
    },

    async addTekToDB(context, payload) {
      try {
        db.collection("tekenaars")
          .add({
            voornaam: payload.voornaam || "",
            adres: payload.adres || "",
            woonplaats: payload.woonplaats || "",
            achternaam: payload.achternaam || "",
            kvknummer: payload.kvknummer || "",
            opleiding: payload.opleiding || "",
            email: payload.email || "",
            werkgebied: payload.werkgebied || "",
            tekenprogramma: payload.tekenprogramma || "",
            telefoonnummer: payload.telefoonnummer || "",
            bedrijfsnaam: payload.bedrijfsnaam || "",
            disciplines: payload.disciplines || [],
            aantekening: payload.aantekening || "",
            kvkingeschreven: "Ja"
          })
          .then(function() {
            alert("Toevoegen nieuwe tekenaar is gelukt! LET OP: reload de pagina :)")
          })
      } catch (error) {
        console.error("Error writing document: ", error)
        alert("Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur")
      }
    },

    async addOpdrToDB(context, payload) {
      try {
        db.collection("opdrachten")
          .add({
            ...payload,
            status: "Nieuw"
          })
          .then(function() {
            alert("Toevoegen nieuwe opdracht is gelukt!")
          })
      } catch (error) {
        console.error("Error writing document: ", error)
        alert("Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur")
      }
    },

    async duplicateOpdrToDB(context, payload) {
      try {
        db.collection("opdrachten").add({
          ...payload,
          status: "Nieuw"
        })
      } catch (error) {
        console.error("Error writing document: ", error)
        alert("Opslaan van kopie opdracht is niet gelukt, probeer het opnieuw of neem contact op met Christiaan")
      }
    },

    //Email akkoordmail naar tek bij nieuwe opdr
    async sendEmail(context, payload) {
      const callable = functions.httpsCallable("zetOpdrachtUitNaarTekenaar")
      return callable(payload).then(() =>
        // do something here
        alert("email succesvol verstuurd naar tek")
      )
    },

    //Email market naar alle tekenaars binnen discipline
    async sendMarketingEmail(context, payload) {
      const callable = functions.httpsCallable("marketingEmail")
      return callable({
        emailList: payload.emaillistholder,
        opdrachtnummer: "CDT.2020." + payload.opdrachtnummer,
        discipline: payload.discipline,
        tekenprogramma: payload.tekenprogramma,
        intakeveld: payload.intakeveld
      }).then(() =>
        // do something here
        alert("email succesvol verstuurd naar tek")
      )
    },
    //Email market TESTTEST naar alle tekenaars binnen discipline
    async sendMarketingEmailTEST(context, payload) {
      const callable = functions.httpsCallable("marketingEmail")
      return callable({
        // emailList: payload.emaillistholder,
        opdrachtnummer: "CDT.2020." + payload.opdrachtnummer,
        discipline: payload.discipline,
        tekenprogramma: payload.tekenprogramma,
        intakeveld: payload.intakeveld
      }).then(() =>
        // do something here
        alert("test email succesvol verstuurd")
      )
    },

    // DB Write Functions

    // DELETE tekenaar
    async deleteTekenaar(context, payload) {
      db.collection("tekenaars")
        .doc(payload)
        .delete()
        .then(function() {
          alert("Tekenaar is verwijderd")
        })
        .catch(function(error) {
          console.error("Error bij verwijderen van tekenaar: ", error)
        })
    },

    // OnHold opdracht
    async onholdOpdracht(context, payload) {
      db.collection("opdrachten")
        .doc(payload)
        .update({
          onhold: true
        })
    },

    // ANNULEER opdracht
    async annuleerOpdracht(context, payload) {
      db.collection("opdrachten")
        .doc(payload)
        .update({
          geannuleerd: true
        })
    },

    async zetOpdrachtOnHold(context, payload) {
      db.collection("opdrachten")
        .doc(payload)
        .update({
          onhold: true
        })
    },

    async zetOpdrachtTerug(context, payload) {
      db.collection("opdrachten")
        .doc(payload)
        .update({
          geannuleerd: false
        })
    },

    async maakOpdrachtWeerActief(context, payload) {
      db.collection("opdrachten")
        .doc(payload)
        .update({
          onhold: false
        })
    },

    // voeg logentry toe aan log van opdracht toe
    async updateOpdrLog(context, payloadLog) {
      db.collection("opdrachten")
        .doc(payloadLog.id)
        .update({
          log: firebase.firestore.FieldValue.arrayUnion(payloadLog.log)
        })
    },

    // voeg logentry toe aan log van opdracht toe
    async updateTekLog(context, payloadLog) {
      db.collection("tekenaars")
        .doc(payloadLog.id)
        .update({
          log: firebase.firestore.FieldValue.arrayUnion(payloadLog.log)
        })
    },

    async updateOpdrStatus(context, payload) {
      try {
        db.collection("opdrachten")
          .doc(payload.opdrachtid)
          .update({
            status: payload.status
          })
      } catch (e) {
        alert("Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur", e)
      }
    },

    async saveOpdrChanges(context, payload) {
      // DEZE FUNCTIE TRIGGERDE WEL MAAR KON GEEN ERRORS OPVANGEN VANWEGE DE ASYNC
      // db.collection("opdrachten").doc(payload.id).update({
      //   email: payload.email,
      //   telefoonnummer: payload.telefoonnummer || "",
      //   intake: payload.intake || "",
      //   disciplines: payload.disciplines || "",
      //   omschrijving: payload.omschrijving || "",
      //   bedrijfsnaam: payload.bedrijfsnaam || "",
      //   gemarket: payload.gemarket ,
      // }).then(function() {
      //   alert("Wijzigingen succesvol opgeslagen")
      // }).catch(function(error) {
      //   console.error("Error writing document: ", error);
      //   alert("Er is iets fout gegaan bij het opslaan")
      // });

      // OPLOSSING: TRY -> CATCH BLOK
      try {
        db.collection("opdrachten")
          .doc(payload.id)
          .update({
            email: payload.email,
            telefoonnummer: payload.telefoonnummer || "",
            intake: payload.intake || "",
            disciplines: payload.disciplines || "",
            omschrijving: payload.omschrijving || "",
            bedrijfsnaam: payload.bedrijfsnaam || "",
            gemarket: payload.gemarket || "Nee",
            tekenprogramma: payload.tekenprogramma || "",
            werkplek: payload.werkplek || "",
            typeopdracht: payload.typeopdracht || "",
            voornaam: payload.voornaam || "",
            achternaam: payload.achternaam || ""
          })
          .then(function() {
            alert("Wijzigingen succesvol opgeslagen")
          })
      } catch (error) {
        alert("Opslaan niet gelukt... Probeer het opnieuw of neem contact op met de programmeur")
        if (typeof error.response !== "undefined" && typeof error.response.data !== "undefined" && error.response.data !== null) {
          throw new Error(error.response.data)
        } else {
          throw error
        }
      }
    },

    async saveTekChanges(context, payload) {
      db.collection("tekenaars")
        .doc(payload.id)
        .update({
          email: payload.email,
          // disciplines: payload.disciplines,
          telefoonnummer: payload.telefoonnummer,
          aantekening: payload.aantekening,
          bedrijfsnaam: payload.bedrijfsnaam,
          woonplaats: payload.woonplaats,
          kvknummer: payload.kvknummer,
          werkgebied: payload.werkgebied,
          rating: payload.rating,
          adres: payload.adres,
          tekenprogramma: payload.tekenprogramma,
          opleiding: payload.opleiding,
          disciplines: payload.disciplines,
          voornaam: payload.voornaam,
          achternaam: payload.achternaam
        })
        .then(function() {
          alert("Wijzigingen succesvol opgeslagen")
        })
        .catch(function(error) {
          console.error("Error writing document: ", error)
          alert("Er is iets fout gegaan bij het opslaan")
        })
    },

    async koppelTekAanOpdr(context, payload) {
      db.collection("opdrachten")
        .doc(payload.opdrachtid)
        .update({
          tekenaarsid: payload.tekenaarsid
        })
        .then(function() {})
        .catch(function() {})
    },

    async ontkoppelTekVanOpdr(context, payload) {
      db.collection("opdrachten")
        .doc(payload.opdrachtid)
        .update({
          tekenaarsid: ""
        })
    }
  }
})
